import { Box, BoxProps, createUseVariantStyle, forwardRef } from '@bonusly/design-system';

import { DropdownVariant } from './types';

interface Props extends BoxProps {
	role?: string;
	variant?: DropdownVariant;
}

const useVariantStyle = createUseVariantStyle({
	variant: {
		floating: {
			borderRadius: 'md',
			_focus: { backgroundColor: 'secondary.bgAlpha' },
			_hover: { backgroundColor: 'secondary.bgAlpha' },
		},
		staticControlledHighlight: {
			backgroundColor: 'bg.subtle',
		},
	},
});

const defaultStyles = {
	backgroundColor: 'transparent',
	border: 0,
	borderRadius: 'sm',
	cursor: 'pointer',
	listStyleType: 'none',
	p: 2,
	transitionDuration: 'normal',
	transitionProperty: 'common',
	_focus: { backgroundColor: 'secondary.bgAlpha' },
	_hover: { backgroundColor: 'secondary.bgAlphaHover' },
};

export const DropdownOption = forwardRef(({ variant, ...rest }: Props, ref) => {
	return <Box as="li" role="option" tabIndex={0} ref={ref} {...defaultStyles} {...useVariantStyle({ variant })} {...rest} />;
});

export type { Props as DropdownOptionProps };
